import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarService } from '../../../services/sidebar.service';
import { BaseService } from '../../../services/base.service';
import { Router } from '@angular/router';
import { StackedSidebarService } from '../../../services/stacked-sidebar.service';
import { ChatService } from '../../../services/chat.service';
import { environment } from '../../../../environments/environment';
import { PERMISSIONS } from '../../../enum/constants';
import { TranslateService } from '@ngx-translate/core';
import { WAREHOUSE_PAGES } from '../../warehouse/warehouse.utils';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LeftMenuComponent implements OnInit {
  opened!: boolean;
  show: boolean = false;
  public version = environment.version;
  public subCrm = [
    { icon: 'lead', is_svg: true, tkey: 'leads', url: '/leads', key: PERMISSIONS.CRM_DEAL },
    { icon: 'deal', is_svg: true, tkey: 'deals', url: '/deals', key: PERMISSIONS.CRM_DEAL },
    { icon: 'group', tkey: 'contacts', url: '/contact', key: PERMISSIONS.CONTACTS_ACCESS },
  ];

  public subCrmV2 = [
    { icon: 'lead', is_svg: true, tkey: 'leads', url: '/v2/leads', key: PERMISSIONS.CRM_DEAL },
    { icon: 'deal', is_svg: true, tkey: 'deals', url: '/v2/deals', key: PERMISSIONS.CRM_DEAL },
    { icon: 'group', tkey: 'contacts', url: '/v2/contacts', key: PERMISSIONS.CONTACTS_ACCESS },
    { icon: 'apartment', tkey: 'companies', url: '/v2/companies', key: PERMISSIONS.CONTACTS_ACCESS },
    { icon: 'inbox', tkey: 'products', url: '/warehouse/products' },
    { icon: 'payment', tkey: 'payments', url: '/v2/payments', key: PERMISSIONS.CRM_DEAL },
    { icon: 'receipt_long', tkey: 'prro.title', url: '/v2/prro', key: PERMISSIONS.CASH_REGISTER_OPERATIONS },
  ];

  public subLogistic = [
    {
      svg: 'assets/svgs/integrations/nova_poshta_white.svg',
      icon: 'mark_as_unread',
      tkey: 'nova_poshta',
      url: '/logistic/nova-poshta',
      hidden: !this.baseService.currentCompanyInfo.settings.is_nova_poshta,
    },
    {
      svg: 'assets/svgs/integrations/ukr_poshta_icon_white.svg',
      icon: 'local_post_office',
      tkey: 'ukr_poshta',
      url: '/logistic/ukr-poshta',
      hidden: !this.baseService.currentCompanyInfo.settings.is_ukr_poshta,
    },
    { icon: 'settings', tkey: 'settings', url: '/logistic/settings' },
  ];

  public subSetting = [
    { icon: 'sync_alt', tkey: 'general', url: '/settings/general' },
    { icon: 'manage_accounts', tkey: 'User_profile', url: '/settings/profile' },
    { icon: 'manage_accounts', tkey: 'CompanySettings', url: '/settings/company' },
  ];

  public subSpace = [{ icon: 'cloud_upload', tkey: 'disk', url: '/file-system' }];

  public subCollaboration = [
    {
      icon: 'hard_drive',
      tkey: 'disk',
      url: '/file-system',
      hidden:
        !this.baseService.company.settings.is_jespace ||
        !this.baseService.currentUserInfo.permissions.includes(PERMISSIONS.FILES_ACCESS),
    },
    { icon: 'calendar_month', tkey: 'calendar', disabled: true },
    { icon: 'mail', tkey: 'mail', disabled: true },
  ];

  public subPeople = [{ icon: 'people', tkey: 'people', url: '/team' }];

  public subWareHouse = WAREHOUSE_PAGES.map((page) => ({ ...page, url: `/warehouse/${page.path}` }));

  public subMarket = [
    { icon: 'storefront', tkey: 'store', url: '/marketplace' },
    {
      svg: 'assets/svgs/integrations/olx.svg',
      icon: 'storefront',
      tkey: 'power_olx_v2',
      url: '/application/power-olx-v2',
      hidden: !this.baseService.currentCompanyInfo.settings.is_power_olx_v2,
    },
    // {
    //   svg: 'assets/svgs/integrations/olx.svg',
    //   icon: 'storefront',
    //   tkey: 'PowerOLX',
    //   url: '/application/olx',
    //   key: 'OLX_TOOL',
    //   hidden: !this.baseService.currentCompanyInfo.application_keys.includes('OLX_TOOL'),
    // },
    {
      svg: 'assets/svgs/integrations/ringostat-logo.svg',
      tkey: 'ringostat',
      url: '/application/ringostat',
      key: 'RINGOSTAT',
      hidden: !this.baseService.currentCompanyInfo.application_keys.includes('RINGOSTAT'),
    },
    {
      icon: 'construction',
      tkey: 'sites',
      url: '/application/sites',
      hidden: !this.baseService.currentCompanyInfo.settings.is_sites,
    },
  ];

  public menuList: any[] = [
    { icon: 'leaderboard', tkey: 'home', url: '/dashboard' },
    {
      icon: 'apartment',
      tkey: 'structure',
      sub: this.subPeople,
      isBeta: false,
      hidden:
        !this.baseService.currentUserInfo.permissions.includes(PERMISSIONS.TEAM_ACCESS) &&
        !this.baseService.currentUserInfo.permissions.includes(PERMISSIONS.TEAM_ACTION) &&
        !this.baseService.currentUserInfo.permissions.includes(PERMISSIONS.ROLE_CHANGE_OWN_ROLE_ACCESS),
    },
    { icon: 'filter_alt', tkey: 'CRM', sub: this.subCrm, isBeta: false, key: PERMISSIONS.CRM_ACCESS },
    {
      icon: 'filter_alt',
      tkey: 'CRM 2.0',
      sub: this.subCrmV2,
      isBeta: true,
      key: PERMISSIONS.CRM_ACCESS,
      hidden: !this.baseService.currentCompanyInfo.settings.is_crm_v2,
    },
    { icon: 'task_alt', tkey: 'tasks', url: '/tasks' },
    // { icon: 'multiple_stop', tkey: 'Integrations', url: '/integration', key: PERMISSIONS.INTEGRATION_ACCESS },
    {
      icon: 'hub',
      tkey: 'channels',
      url: '/channel',
      isWarning: this.baseService.isExpired,
      anyPermissions: [PERMISSIONS.CHANNELS_ACCESS, PERMISSIONS.CHANNEL_GROUPS_CHANGE_OWN_ACCESS],
    },
    { icon: 'local_shipping', tkey: 'logistics', sub: this.subLogistic, key: PERMISSIONS.LOGISTICS_ACCESS },
    {
      icon: 'warehouse',
      tkey: 'warehouse',
      sub: this.subWareHouse,
      // Product items and the stock automation work on the CRM 2.0 cards
      hidden: !this.baseService.currentCompanyInfo.settings.is_crm_v2,
    },
    { icon: 'chat', tkey: 'chats', isChat: true, key: PERMISSIONS.CHATS_ACCESS },
    { icon: 'groups', tkey: 'collaboration', sub: this.subCollaboration },
    { icon: 'apps', tkey: 'applications', sub: this.subMarket, key: PERMISSIONS.APPS_ACCESS },
    { icon: 'settings', tkey: 'settings', sub: this.subSetting, key: PERMISSIONS.SETTINGS_ACCESS },
    { icon: 'precision_manufacturing', url: '/automation', tkey: 'automation', key: PERMISSIONS.AUTOMATION_ACCESS },
    { icon: 'payment', tkey: 'Payment', url: '/payment', key: PERMISSIONS.PAYMENT_ACCESS },
    { icon: 'support_agent', tkey: 'support', url: '/support' },
    { icon: 'lightbulb', tkey: 'proposals', url: '/proposals', isBeta: true },
    { icon: 'account_tree', tkey: 'automation_flow_menu', url: '/automation-flow', isBeta: true, hidden: !this.baseService.user.is_admin },
    { icon: 'web', tkey: 'components', url: '/components', hidden: !this.baseService.user.is_admin, },
  ];

  lastOpenedItem: any = null;
  urlHistoryVersion = '/history-version';

  constructor(
    public readonly sidebarService: SidebarService,
    public readonly baseService: BaseService,
    public readonly chatService: ChatService,
    public readonly stackedSidebarService: StackedSidebarService,
    private readonly router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    const per = this.baseService.currentUserInfo.permissions;
    this.menuList = this.menuList.filter((item) =>
      (!item.key || per.includes(item.key)) &&
      (!item.anyPermissions || item.anyPermissions.some((key: PERMISSIONS) => per.includes(key))),
    );

    this.sidebarService.opened$.subscribe((v) => {
      this.opened = v;
      if (!this.opened) this.menuList[1].active = false;
    });

    this.baseService.currentCompanyInfo$.subscribe((data) => {
      const applications = this.subMarket.filter((v: any) => v.key);
      applications.forEach((v: any) => {
        v.hidden = !this.baseService.currentCompanyInfo.application_keys.includes(v.key);
      });
      this.menuList.forEach((v) => {
        if (v.key === 'Логістика') {
          v.hidden = !this.baseService.currentCompanyInfo.application_keys.includes('LOGISTIC');
        }
      });
    });
  }

  openMenu() {
    if (!this.baseService.isMobile) this.show = true;
  }

  closeMenu() {
    if (!this.baseService.isMobile) this.show = false;
  }

  openSubMenu(item: any) {
    if (this.lastOpenedItem && this.lastOpenedItem !== item) {
      this.lastOpenedItem.active = false;
    }

    this.lastOpenedItem = item;
    item.active = !item.active;

    if (!this.opened && item.active) {
      this.sidebarService.toggle();
    }
  }

  closeSidebar() {
    if (this.baseService.isMobile && this.opened) this.sidebarService.toggle();
  }

  public openChat() {
    this.stackedSidebarService.openChats().subscribe(() => {});
  }

  getCountSub(item: any) {
    const copy = { ...item };
    const sub = copy.sub.filter((v: any) => !v.hidden);
    return sub.length;
  }
}
